import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si nunca estudié PNL antes?',
    a: 'Sí. El Sistema Soberano está diseñado para personas sin experiencia previa en PNL. Cada concepto se explica desde cero con lenguaje claro y ejemplos del contexto argentino. No necesitás ningún conocimiento previo. Solo ganas de trabajar tu mundo interior.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital. Después del pago recibís un email con acceso a los 6 tomos y los 6 bonos en formato PDF. El acceso es inmediato, generalmente en menos de 5 minutos. Podés descargarlos en tu celular, tablet o computadora y leerlos sin internet después de la descarga.'
  }, {
    q: '¿Puedo usarlo para trabajar con otras personas?',
    a: 'Sí. El Sistema Soberano incluye formación para uso personal y profesional. El Tomo 5 de Propósito y Carrera incluye específicamente cómo monetizar lo que aprendés y trabajar con clientes. El Protocolo de Emergencia agrega herramientas de uso profesional inmediato.'
  }, {
    q: '¿Funciona con el país como está?',
    a: 'Especialmente con el país como está. El Sistema Soberano fue diseñado específicamente para el contexto argentino. La inflación, la incertidumbre y la presión del entorno no son obstáculos del sistema. Son el campo donde el sistema demuestra todo su valor. Porque cuando el afuera no cambia, cambiar el adentro es la única soberanía real disponible.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total sin preguntas. Si abrís el material y no es lo que esperabas, te devolvemos el 100% del dinero. Sin formularios. Sin burocracia. Sin drama. Escribís un mensaje y listo. Así de simple.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-dark-card/30" data-id="element-104">
      <div className="max-w-3xl mx-auto" data-id="element-105">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-heading font-bold text-center text-white mb-16" data-id="element-106">
          LO QUE MÁS NOS PREGUNTAN
        </motion.h2>

        <div className="space-y-4" data-id="element-107">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-dark-border rounded-xl bg-dark overflow-hidden" data-id="element-108">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-109">
                <span className="font-bold text-white pr-8" data-id="element-110">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-111" />
              </button>

              <AnimatePresence data-id="element-112">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-113">
                    <div className="px-6 pb-6 text-gray-300 leading-relaxed border-t border-dark-border/50 pt-4" data-id="element-114">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}